<template>
  <div>
    <form
      action=""
      method="POST"
      class="mt-3"
      :class="{ 'is-response' : isResponse }"
      @submit.prevent="submit"
    >
      <div class="d-flex flex-wrap flex-column flex-lg-row justify-content-center justify-content-lg-between align-items-center align-items-lg-start">
        <div class="mr-lg-4 mb-3 mb-lg-0">
          <div
            class="author-image-circle background-cover shadow-light"
            :style="profileImage"
            v-if="user"
          ></div>
        </div>
        <div class="flex-grow-1 mr-lg-4 align-self-stretch comment-content">
          <textarea
            class="form-control default w-100"
            name="content"
            v-model.trim="$v.comment.content.$model"
            ref="contentInput"
          ></textarea>
        </div>
        <div
          class="mt-3 actions"
          :class="{
            'mt-lg-0 ' : !isResponse
          }"
        >
          <Button
            class="btn-outline-color2 mr-2"
            v-if="isResponse"
            @click="cancelResponse"
          >
            Cancelar
          </Button>
          <Button
            class="btn btn-primary"
            :disabled="$v.$invalid"
            :loading="isLoading"
            type="submit"
            v-if="user"
          >
            Comentar
          </Button>
          <Button
            class="btn btn-primary"
            :disabled="$v.$invalid"
            @click="commentAuthModal"
            type="button"
            v-else
          >
            Comentar
          </Button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>

import Button from '@/components/common/Button/Button.vue'
import { required } from 'vuelidate/lib/validators'
import variables from '@/mixins/variables'

import CommentsService from '@/modules/comments/services/comments-service'

export default {
  name: 'CommentForm',
  mixins: [variables],
  props: {
    user: Object,
    entityId: {
      type: String,
      required: true
    },
    entityType: {
      type: String
    },
    parentId: {
      type: String
    },
    isVisible: {
      type: Boolean
    }
  },
  data () {
    return {
      comment: {
        content: ''
      },
      isLoading: false
    }
  },
  validations () {
    return {
      comment: {
        content: { required }
      }
    }
  },
  mounted () {
    if (this.isVisible) this.$refs.contentInput.focus()
  },
  computed: {
    profileImage () {
      return {
        backgroundImage: this.user ? `url('${this.user.avatar}')` : `url('${this.noAvatarUrl}')`
      }
    },
    isResponse () {
      return !!this.parentId
    }
  },
  components: {
    Button
  },
  methods: {
    async submit () {
      this.isLoading = true
      const data = Object.assign({}, this.comment)
      data.entityId = this.entityId
      data.entityType = this.entityType
      data.parentId = this.parentId
      try {
        const comment = await CommentsService.createComment(data)
        this.comment.content = ''
        this.$emit('comment-created', comment)
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.isLoading = false
    },
    cancelResponse () {
      this.comment.content = ''
      this.$emit('cancel-comment')
    },
    commentAuthModal () {
      if (!this.user) {
        this.$bvModal.show('auth-modal')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .is-response {
    .comment-content {
      margin-right: 0 !important;
    }

    .actions {
      width: 100%;
      text-align: right;
    }
  }
</style>
